import { Link } from 'react-router-dom';
import { Book, Mail, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Book className="w-8 h-8 text-amber-500" />
              <span className="text-xl font-bold text-white">PictureBook.co</span>
            </div>
            <p className="text-sm text-gray-400">
              Create stunning photo albums with AI-powered organization and beautiful design.
            </p>
            <div className="flex gap-4 mt-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-amber-500 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-amber-500 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-amber-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-amber-500 transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/connected-accounts" className="hover:text-amber-500 transition-colors">
                  Connected Accounts
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:support@picturebook.co" className="hover:text-amber-500 transition-colors">
                  Help Center
                </a>
              </li>
              <li>
                <a href="mailto:support@picturebook.co" className="hover:text-amber-500 transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  href="https://developers.facebook.com/apps/1770510201018530/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-amber-500 transition-colors"
                >
                  Facebook Integration
                </a>
              </li>
              <li>
                <a href="/data-deletion.html" target="_blank" className="hover:text-amber-500 transition-colors">
                  Delete Your Data
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="/privacy-policy.html" 
                  target="_blank"
                  className="hover:text-amber-500 transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="/terms-of-service.html" 
                  target="_blank"
                  className="hover:text-amber-500 transition-colors"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a 
                  href="/data-deletion.html" 
                  target="_blank"
                  className="hover:text-amber-500 transition-colors"
                >
                  Data Deletion Instructions
                </a>
              </li>
              <li>
                <a href="mailto:privacy@picturebook.co" className="hover:text-amber-500 transition-colors">
                  Delete My Data
                </a>
              </li>
              <li>
                <a href="mailto:legal@picturebook.co" className="hover:text-amber-500 transition-colors">
                  Legal Inquiries
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} PictureBook.co. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Mail className="w-4 h-4" />
              <a href="mailto:contact@picturebook.co" className="hover:text-amber-500 transition-colors">
                contact@picturebook.co
              </a>
            </div>
          </div>
          <div className="text-center mt-4 text-xs text-gray-500 space-y-2">
            <p>Made with ❤️ for preserving your precious memories</p>
            <p>
              Need to delete your data?{' '}
              <a 
                href="/data-deletion.html" 
                target="_blank" 
                className="text-amber-400 hover:text-amber-300 underline"
              >
                View instructions
              </a>
              {' '}or email{' '}
              <a 
                href="mailto:privacy@picturebook.co" 
                className="text-amber-400 hover:text-amber-300 underline"
              >
                privacy@picturebook.co
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
